module.exports = __webpack_public_path__ + "img/history2.68204af1.jpeg";